import { useEffect, useState } from "react";
import axios from "axios";
import { BookMarked, Loader2, Trash2, Play } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StylerBrands({ onUse }) {
  const [brands, setBrands] = useState(null);

  const load = async () => {
    try { const r = await axios.get(`${API}/template-styler/brands`); setBrands(r.data.brands); }
    catch (_) { toast.error("Couldn't load brands"); setBrands([]); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (b) => {
    if (!window.confirm(`Delete brand "${b.name}"?`)) return;
    try { await axios.delete(`${API}/template-styler/brands/${b.id}`); toast.success("Brand deleted"); load(); }
    catch (_) { toast.error("Couldn't delete brand"); }
  };

  if (!brands) return <div className="ts-loading"><Loader2 className="animate-spin" size={18} /> Loading brands…</div>;

  return (
    <section className="ts-panel" data-testid="styler-brands">
      <div className="ts-section-head"><span><BookMarked size={15} /> Saved brands</span><small>Pick a brand to load its palette & fonts into the Styler and regenerate instantly</small></div>
      {brands.length === 0 ? (
        <div className="ts-empty" data-testid="styler-brands-empty">No brands saved yet — analyse a logo, adjust, then hit <b>Save brand</b>.</div>
      ) : (
        <div className="ts-brand-grid">
          {brands.map((b) => (
            <div key={b.id} className="ts-brand-card" data-testid={`styler-brand-${b.id}`}>
              <div className="ts-brand-logo" style={{ background: b.neutral || "#fff" }}>
                {b.logo_url ? <img src={b.logo_url} alt={b.name} /> : <span style={{ color: b.primary }}>{b.name?.[0]}</span>}
              </div>
              <div className="ts-brand-body">
                <h4>{b.name}</h4>
                <div className="ts-brand-swatches">
                  {["primary", "accent", "secondary", "neutral"].map((r) => <i key={r} style={{ background: b[r] }} title={`${r} ${b[r]}`} />)}
                </div>
                <p>{b.hero_font} · {b.support_font}</p>
              </div>
              <div className="ts-brand-actions">
                <button className="ts-btn primary sm" onClick={() => onUse(b)} data-testid={`styler-use-brand-${b.id}`}><Play size={13} /> Use</button>
                <button className="ts-icon-btn danger" onClick={() => remove(b)} title="Delete" data-testid={`styler-delete-brand-${b.id}`}><Trash2 size={13} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
